var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2560_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6544 2.80786V22.8034H0.204102V2.80898L15.6544 2.80786Z",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6744 5.60019C19.2532 3.23889 17.7352 0.87267 15.2837 0.315099C12.8322 -0.242471 10.3756 1.21974 9.79678 3.58105C9.21792 5.94235 10.736 8.30857 13.1874 8.86614C15.6389 9.42371 18.0955 7.96149 18.6744 5.60019Z",
    fill: "white",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.70276 15.936H13.1138",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.70276 13.8494H13.1138",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.70276 11.7629H13.1138",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.70276 18.0371H13.1138",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.70276 20.1382H9.67378",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.70276 9.67529H9.67378",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.9636 4.70113L13.2724 6.07304L16.506 3.10675",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2560_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIcon);
export default __webpack_public_path__ + "static/media/manual-icon.f92f1ee4da7fd61dcfba7ef1308dfcae.svg";
export { ForwardRef as ReactComponent };